import UsersTableHelper from './users-table-helper';
import usersFuncHelper from './users-functions-helper';


const UserHelpers = {
    TableMain: UsersTableHelper,
    Functions: usersFuncHelper,
}

export default UserHelpers;